<template>
    <div class="wrap">
        <div class="breadcrumb">
            <router-link to="/">首页</router-link>
            <span>&nbsp;&gt;&nbsp;</span>
            <router-link to="/news">品牌动态</router-link>
            <span>&nbsp;&gt;&nbsp;</span>
            <span>前沿观察</span>
        </div>
        <div class="tab">
            <div class="item" 
            :class="{active: activeIndex == 0}"
            @click="activeIndex = 0">青年理想工作空间</div>
            <div class="item" 
            :class="{active: activeIndex == 1}"
            @click="activeIndex = 1">【IN观点】</div>
        </div>
        <!-- 青年理想工作空间 -->
        <div class="content" v-if="activeIndex == 0">
            <div class="workspace1">
                <div class="download">
                    <img :src="data.white_paper.image" alt="" class="cover">
                    <p><a :href="data.white_paper.file">点击下载完整版白皮书</a></p>
                </div>
                <div class="list_content">
                    <div class="title">《青年理想工作空间白皮书》</div>
                    <ul class="list">
                        <li class="item" v-for="(item, index) in list" :key="index">
                            <router-link :to="`/news/detail?id=${item.id}`">{{item.title}}</router-link>
                        </li>
                    </ul>
                    <div class="more"><router-link to="/news/youthworkspace">更多&gt;&gt;</router-link></div>
                    <router-link class="more_arrow" to="/news/youthworkspace"></router-link>
                </div>
            </div>
            <div class="workspace2">
                <div class="title">《打工人理想博物馆》</div>
                <div class="text_content">
                    <div class="text">
                        <p class="p1">{{data.museum.title}}</p>
                        <p>{{data.museum.desc}}</p>
                    </div>
                    <img :src="data.museum.image" alt="" class="cover">
                </div>
            </div>
            <template v-if="data.museum.pictures.length > 0">
                <NewsImages :data="data.museum.pictures"/>
            </template>
        </div>
        <!-- in观点 -->
        <div class="content" v-if="activeIndex == 1">
            <NewsList :data="newsData" :page="page" :total="total" :isLoading="isLoading" @showMore="showMore"/>
        </div>
    </div>
</template>

<script>
import NewsImages from '../../components/newsImages.vue';
import NewsList from '../../components/newsList.vue';
import config from '../../config';
export default {
    name: "news1",
    data() {
        return {
            activeIndex: 0,
            list: [],
            data: {
                white_paper: {
                    image: '',
                    file: ''
                },
                museum: {
                    pictures: []
                },
            },
            newsData: [],
            page: 1,
            limit: 10,
            total: 1,
            isLoading: false,
        };
    },
    computed: {},
    components: {
        NewsList,
        NewsImages,
        
    },
    mounted() {
        this.getData();
        this.getData2();
        this.getText();
    },
    destroyed() {},
    watch: {},
    methods: {
        showMore(){
            this.page++;
            this.getData();
        },
        getData(){
            let self = this;
            this.isLoading = true;
            this.$store.dispatch('getNews', { type: 2, page: this.page, limit: this.limit }).then((result) => {
                self.isLoading = false;
                self.newsData = self.newsData.concat(result.list);
                self.total = result.last_page;
            }).catch((err) => {
                
            });
        },
        getData2(){
            let self = this;
            this.$store.dispatch('getNews', { type: 3, page: 1, limit: 5 }).then((result) => {
                self.list = result.list;
            }).catch((err) => {
                
            });
        },
        getText(){
            let self = this;
            this.axios.get(config.inViewpoint)
            .then((result) => {
                if (result.data.code == 100) {
                    self.data = result.data.data
                }
            }).catch((err) => {
                
            });
        }
    },
};
</script>

<style scoped lang="scss">
.breadcrumb{
    margin: .35rem 0 .7rem;
    @media only screen and (max-width: 1200px) {
        display: none;
    }
    :last-child{
        font-weight: bold;
    }
}
.tab{
    display: flex;
    justify-content: center;
    margin-bottom: .6rem;
    .item{
        margin: 0 .3rem;
        font-size: .26rem;
        color: rgba($color: #000000, $alpha: .5);
        cursor: pointer;
        &:hover,
        &.active{
            color: #ff4028;
            border-bottom: 1px solid #ff4028;
        }
    }
    @media only screen and (max-width: 1200px) {
        margin-bottom: .7rem;
        .item{
            flex: 1;
            height: 1.45rem;
            border: 1px solid #bfc7c3 !important;
            margin: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: .48rem;
            background: #e6e6e6;
            border-radius: 0 .2rem 0 0;
            &:nth-of-type(2){
                border-radius: .2rem 0 0 0;
            }
            &:hover{
                color: rgba($color: #000000, $alpha: .5);
                border-bottom: none;
            }
            &.active{
                background: none;
                color: #ff4028;
                text-decoration: underline;
            }
        }
    }
}
.workspace1{
    display: flex;
    margin-bottom: 1rem;
    .download{
        width: 2.18rem;
        text-align: center;
        margin: 0 .8rem 0 .6rem;
        .cover{
            width: 100%;
            margin-bottom: .1rem;
        }
        a{
            border-bottom: 1px solid #000;
        }
    }
    .list_content{
        .title{
            font-size: .26rem;
            margin: .4rem 0;
        }
        .list{
            line-height: 1.6;
            .item{
                display: flex;
                align-items: center;
                &::before{
                    content: "";
                    display: inline-block;
                    width: .08rem;
                    height: .08rem;
                    border-radius: 50%;
                    background: #000;
                    margin-right: .1rem;
                }
                a{
                    border-bottom: 1px solid transparent;
                }
                &:hover,
                &.active{
                    color: #ff4630;
                    &::before{
                        background: #ff4630;
                    }
                    a{
                        border-bottom: 1px solid #ff4630;
                    }
                }
            }
        }
        .more{
            margin-top: .2rem;
            a{
                border-bottom: 1px solid #000;
            }
        }
        .more_arrow{
            display: none;
        }
    }
    @media only screen and (max-width: 1200px) {
        padding: 0 1rem;
        flex-direction: column-reverse;
        .list_content{
            .title{
                font-size: .48rem;
                text-align: center;
                margin-bottom: .7rem;
            }
            .list{
                .item{
                    margin-bottom: .3rem;
                    &::before{
                        width: .2rem;
                        height: .2rem;
                    }
                    a,
                    a:hover,
                    a.active{
                        border-bottom-color: #000;
                    }
                }
            }
            .more{
                display: none;
            }
            .more_arrow{
                display: block;
                width: .48rem;
                height: .61rem;
                background: url('~@/assets/images/icon_arrow_next.svg') no-repeat 0/100%;
                margin: 0 auto;
                transform: rotate(90deg);
            }
        }
        .download{
            width: 100%;
            margin: 0;
            .cover{
                width: 5.4rem;
                margin: 0 auto .8rem;
            }
        }
    }
}
.workspace2{
    margin-bottom: .6rem;
    .title{
        font-size: .26rem;
        margin-bottom: .4rem;
    }
    .text_content{
        display: flex;
        align-items: center;
        .text{
            line-height: 1.6;
            .p1{
                font-size: .2rem;
                margin-bottom: .15rem;
            }
        }
        .cover{
            width: 5.46rem;
            margin-left: .5rem;
        }
    }
    @media only screen and (max-width: 1200px) {
        .title{
            text-align: center;
            font-size: .48rem;
            margin-bottom: .4rem;
        }
        .text_content{
            display: block;
            .text{
                padding: 0 1rem;
                margin-bottom: .4rem;
                .p1{
                    font-weight: bold;
                    text-align: center;
                    font-size: .36rem;
                    margin-bottom: .3rem;
                }
            }
            .cover{
                width: 100%;
                margin: 0;
                display: none;
            }
        }
    }
}
</style>